import axios from './axios.js'
class Interface {
    //获取问题列表
    getRequest(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //交叉分析获取列表数据
    getCrossList(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //交叉分析获取饼状图
    pieChart(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //交叉分析获取柱状图
    histogram(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //保存创建的问卷
    saveQuestion(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //更新当前正在操作的问卷
    updateQuestion(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
     //获取人员属性动态值
     getFieldValue(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //获取问卷列表
    loadQuestionData(url, fun, data) {
        url += data.url;
        delete data.url;
        axios.postRequest(url, fun, data);
    }
    //从问卷列表删除问卷
    deleteFromQuestionData(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //保存创建题目
    saveQuestionSubject(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //获取当前问卷所有的题目
    // getCurrentQuestionAllSubject(url, fun, data) {
    //     axios.postRequest(url, fun, data);
    // }
    //删除问题
    deleteQuestionSubject(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //上移问题
    moveQuestionSubjectUp(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //更新题目内容
    updateQuestionSubject(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //下移问题
    moveQuestionSubjectDown(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //回收条形图
    getRecoveryCharts(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //回收列表
    getRecoveryTable(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //获取回收页删除
    getRecoveryDel(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //获取答题二维码
    propagationQR(url, fun, data) {
        axios.qeCodepostRequest(url, fun, data);
    }
    //回收导出
    getRecoveryDownload(url, fun, data) {
        if (url.endsWith("/")) {
            url = url.substring(0, url.length - 1);
        }
        url += "?"
        for (var key in data) {
            url = `${url}${key}=${data[key]}&`
        }
        url = url.substring(0, url.length - 1);
        axios.export(url);
    }
    //单题分析
    singleQuestionAnalysis(url, fun, data) {
        axios.postRequest(url, fun, data);
    }
    //答卷提交
    // saveQuestionAnswer(url, fun, data) {
    //     axios.postRequest(url, fun, data);
    // }
    
}
let interfaceClass = new Interface();
export default interfaceClass